import { OrderFormStoreType } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { useTranslate } from '@tolgee/react'
import { DataControlCard } from '@tom-ui/ui'
import { IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import {
  ContainerCardData,
  UnitAdditionalAttributes,
  UnitContainerCard,
} from '../molecules/UnitContainerCard'

interface Props {
  formStore?: IFormStore<OrderFormStoreType>
  initialValues?: Partial<OrderFormStoreType>
  unitAdditionalAttributes?: UnitAdditionalAttributes
  container?: ContainerCardData
  allowEdit?: boolean
  hideActions?: boolean
  onClickSave?: () => Promise<void>
  onClickEdit?: () => void
}

export const OrderUnitViewCard = observer(
  ({
    formStore,
    initialValues,
    unitAdditionalAttributes,
    container,
    allowEdit,
    hideActions,
    onClickEdit,
    onClickSave,
  }: Props) => {
    const { t } = useTranslate()
    if (!container) return

    return (
      <DataControlCard
        title={t('unit', 'Unit')}
        allowEdit={allowEdit}
        hideActions={hideActions}
        onClickEdit={onClickEdit}
        onClickSave={onClickSave}
        viewDisplay='block'
        viewComponent={
          <UnitContainerCard
            collapsable
            onSaveAdditionalInformation={onClickSave}
            container={container}
            unitAdditionalAttributes={unitAdditionalAttributes}
            formStore={formStore}
            initialValues={initialValues}
          />
        }
      />
    )
  },
)
